import posthog from "posthog-js";

const withPagePath = (payload = {}) => ({
  page_path: window.location.pathname,
  ...payload,
});

export const captureWentOffline = (payload = {}) => {
  posthog?.capture("user_went_offline", withPagePath(payload));
};

export const captureCameBackOnline = (payload = {}) => {
  posthog?.capture("user_came_back_online", withPagePath(payload));
};

export const captureOfflineBannerShown = (payload = {}) => {
  posthog?.capture("offline_banner_shown", withPagePath(payload));
};

const API_LIFECYCLE_SAMPLE_RATE = 0.02;

const shouldCaptureApiLifecycle = () => {
  try {
    if (localStorage.getItem("debug_api_lifecycle") === "1") {
      return true;
    }
  } catch {
    // localStorage may be unavailable in privacy modes.
  }

  return Math.random() < API_LIFECYCLE_SAMPLE_RATE;
};

export const buildClientRequestId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `req_${Date.now()}_${Math.random().toString(16).slice(2, 10)}`;
};

export const getNetworkContext = () => {
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  return {
    browser_online: navigator.onLine,
    page_visibility: document.visibilityState,
    connection_type: connection?.effectiveType ?? null,
    connection_rtt: connection?.rtt ?? null,
    connection_downlink: connection?.downlink ?? null,
    save_data_enabled: connection?.saveData ?? null,
  };
};

export const captureApiLifecycle = (payload = {}) => {
  if (!shouldCaptureApiLifecycle()) {
    return;
  }

  posthog?.capture("api_request_lifecycle", withPagePath(payload));
};
